export const phonePrefixes = ["050", "052", "053", "054", "055", "057", "058"];
